import styles from './Line.module.css';

type TProps = {
  className?: string;
};

/**
 * A horizontal line component.
 * @param props Component props.
 * @param props.className Optional additional CSS class name.
 * @returns The rendered component.
 */
export const Line = ({ className = '' }: TProps) => {
  return <div className={`${styles.container} ${className}`} />;
};
